import { Component, Input } from '@angular/core';
import { Card } from '@deckplan.io/common';

@Component({
    selector: 'app-pretty-card-list',
    templateUrl: './pretty-card-list.component.html',
    styleUrls: ['./pretty-card-list.component.scss']
})
export class PrettyCardListComponent {

    @Input() public cards: Card[];

}
